import { useGetMeetingLinkQuery } from '@/core/graphql/hooks'

export function useGetMeetingLink(meetingLinkSlug: string) {
  const { data: meetingLinkData, loading: isLoadingMeetingLink } = useGetMeetingLinkQuery({ variables: { slug: meetingLinkSlug } })
  return { meetingLink: meetingLinkData?.meetingLink, isLoadingMeetingLink }
}
